import * as url from "../url.helper";

import { post } from "../api.helper";

export const callBankList = data => post(url.BANK_LIST, data);

export const callFinancierList = data => post(url.FINANCIER_TYPE_LIST, data);

export const callfinListSummary = data => post(url.FINANCIER_TYPE_LIST_SUMMARY, data);

export const callReferredFinancierList = data => post(url.GET_REFERRED_FINANCIER, data);


